import React from 'react';
import { styled } from 'linaria/react';
import { LogoutButton } from '@features/auth/logout';
import { useAuthDataStore, UserAvatar } from '@entities/user';
import { FormatAliasPhone, formatPhoneNumber } from '@shared/lib/phone';
import { Text } from '@shared/ui/atoms';
const UserAvatarMenuContent = () => {
  const phone = useAuthDataStore().getPhone() || '';

  // UserAvatar
  // <LogoutButton />
  // <Text>{phone ? formatPhoneNumber(phone, FormatAliasPhone.SYMBOLS16) : 'Мой профиль'}</Text>

  return <UserAvatarMenuContentWrapper>
      <UserInfoWrapper>
        <UserAvatar />
        <Text family="MTSCompact" size="pL" weight="medium" color="primary">
          {phone ? formatPhoneNumber(phone, FormatAliasPhone.SYMBOLS16) : 'Мой профиль'}
        </Text>
      </UserInfoWrapper>
      <LogoutButton />
    </UserAvatarMenuContentWrapper>;
};
export default UserAvatarMenuContent;
const UserAvatarMenuContentWrapper = /*#__PURE__*/styled('div')({
  name: "UserAvatarMenuContentWrapper",
  class: "u71omw8",
  propsAsIs: false
});
const UserInfoWrapper = /*#__PURE__*/styled('div')({
  name: "UserInfoWrapper",
  class: "u1ilbyhi",
  propsAsIs: false
});

require("./UserAvatarMenuContent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./UserAvatarMenuContent.tsx");